import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { colors } from 'Constants/Colors';
import styled from '@emotion/styled';
import { Flag } from '@mui/icons-material';
import { PRIORITY_ID } from 'Constants/priority';

// Estilos para el wrapper
const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
});

interface Props {
  id: string;
  name: string;
}

const CoursePriorityTag = ({ id, name }: Props) => {
  // Estado para manejar el color del icon
  const icon = useMemo(() => {
    switch (id) {
      case PRIORITY_ID.normativa:
        return <Flag sx={{ color: colors.RED, scale: 0.7 }} />;
      case PRIORITY_ID.institucional:
        return <Flag sx={{ color: colors.GREEN, scale: 0.7 }} />;
      case PRIORITY_ID.tecnica:
        return <Flag sx={{ color: colors.YELLOW, scale: 0.7 }} />;
      default:
        return <Flag sx={{ color: colors.GRAY, scale: 0.7 }} />;
    }
  }, [id, name]);

  return (
    <Wrapper>
      <Typography component="span">{name}</Typography>
      {icon}
    </Wrapper>
  );
};

export default CoursePriorityTag;
